<div class="field-container">
  <div class="input-container body-m">
    <input
      #stationNameInput
      (mousedown)="$event.preventDefault()"
      (click)="setPopoverVisibility(true)"
      (focus)="setPopoverVisibility(true)"
      [value]="stationName"
      [attr.data-test]="dataTestId + '-station'"
      [readOnly]="true"
      [placeholder]="'TROUBLESHOOT.CHARGING_STATION' | translate"
      class="input body-m"
      type="text" />
    @if (popoverVisible) {
      <eop-icon
        [identifier]="'small-chevron-up-filled'"
        [color]="IconColor.NAVIGATIONAL"
        [dataTestId]="dataTestId + '-icon-close'"
        (click)="setPopoverVisibility(true)"
        (focus)="setPopoverVisibility(true)"
        [vaylensFont]="true"></eop-icon>
    } @else {
      <eop-icon
        [identifier]="'small-chevron-down-filled'"
        [color]="IconColor.NAVIGATIONAL"
        [dataTestId]="dataTestId + '-icon-open'"
        (click)="setPopoverVisibility(true)"
        (focus)="setPopoverVisibility(true)"
        [vaylensFont]="true"></eop-icon>
    }
  </div>
</div>

<ng-template #dialogTemplate>
  <div class="dialog" (keydown.escape)="closeDialog()">
    <div class="search-input-container" [class.small-bottom-padding]="minCharsReached">
      <input
        #searchInput
        [attr.data-test]="dataTestId"
        [placeholder]="'GLOBAL.SEARCH' | translate"
        (keydown.escape)="closeDialog()"
        (keyup)="onKeyUpWithinInput($event, searchInput.value)"
        (keydown)="onKeyDownWithinInput($event)"
        class="search-input input-field"
        type="text" />
    </div>
    @if (minCharsReached) {
      <div class="viewport">
        <eop-quick-access-results
          [compact]="true"
          [results]="currentResults"
          [searchInProgress]="searchInProgress"
          (resultClicked)="selected($event)"
          [(selectedResult)]="selectedResult"></eop-quick-access-results>
      </div>
    }
  </div>
</ng-template>
